import styled from "styled-components";

const CategoriesContainer = styled.section`
    margin: 30px 0 30px;
    .item {
        margin-bottom: 30px;
        -webkit-tap-highlight-color: rgba(25, 25, 25, 0.2);
        .img-sec-outer {
            height: 280px;
            position: relative;
            overflow: hidden;
            .img-sec {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                overflow: hidden;
                &:not(.loaded) {
                    background: #efefef;
                }
                img {
                    transition: 0.3s;
                    height: 100%;
                    width: auto;
                    -webkit-backface-visibility: hidden;
                    -webkit-tap-highlight-color: rgba(25, 25, 25, 0.2);
                    text-indent: -9999px;
                }
            }
        }
        .text-sec {
            padding-left: 15px;
            .cat-name {
                color: #333;
            }
        }
        > .inner {
            &:hover {
                .img-sec {
                    img {
                        transform: scale(1.1);
                    }
                }
            }
        }
    }
`;

const H1 = styled.h1`
    font-size: 25px !important;
    font-weight: 800 !important;
    margin-bottom: 5px;
    text-transform: uppercase;
`;

const PageLinkDiv = styled.div`
    color: #757575;
    font-size: 16px;
`;

const LinkDiv = styled.a`
    color: #757575;
    transition: color 0.12s ease-out 0s;
    cursor: pointer;
    text-decoration: none;
    pointer-events: none;

    &:hover {
        color: #757575;
    }
`;

const HeaderContainer = styled.div`
    padding-bottom: 20px;
`;

export { CategoriesContainer, H1, PageLinkDiv, LinkDiv, HeaderContainer };
